// import { Component, OnInit } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { slideToTop } from '../../router-animation/router-animation.component';
import { DatabaseService } from 'src/_services/DatabaseService';
import { _localeFactory } from '@angular/core/src/application_module';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogComponent } from 'src/app/dialog.component';
import * as moment from 'moment';
import { sessionStorage } from 'src/app/localstorage.service';
import { Location } from '@angular/common';
import { ToastrManager } from 'ng6-toastr-notifications';



@Component({
  selector: 'app-site-add',
  templateUrl: './site-add.component.html',
  styleUrls: ['./site-add.component.scss']
})
export class SiteAddComponent implements OnInit {

  fromdata:any={};
  data: any = {};
  savingFlag: boolean = false;
  status = '';
  today_date: any;
  userData: any;
  userId: any;
  userName: any;
  networkType: any = [];
  city_area_list: any = [];
  loader: boolean;
  states: any = [];
  site_data: any = [];
  district_list: any = [];
  addTolistDisabled: boolean = true;



  constructor(public serve: DatabaseService, public router: Router, public location: Location, public rout: Router, public session: sessionStorage, public dialog: DialogComponent, public ActivatedRoute: ActivatedRoute, public toast: ToastrManager) {
    this.today_date = new Date();
    this.userData = JSON.parse(localStorage.getItem('st_user'));
    this.userId = this.userData['data']['id'];
    this.userName = this.userData['data']['name'];
    this.getStateList();
    this.getNetworkType();
    this.getsource_list();
  }

  ngOnInit() {
    this.ActivatedRoute.params.subscribe(params => {
      this.today_date = new Date().toISOString().slice(0, 10);
      this.data.dr_type = params.id;
    });

  }



  processPincode() {
    const pincodeValue = this.data.pincode;
        //  console.log('Entered pincode:', pincodeValue);
    if(pincodeValue.length>5){
      this.serve.post_rqst({'pincode':pincodeValue}, "Enquiry/getPostalInfo").subscribe((result => {
        if (result['statusCode'] == 200) {
         this.data.state=result['result'].state_name
         this.data.district=result['result'].district_name
         this.data.city=result['result'].city  
         console.log("Data",this.data)
         this.getDistrict(1)
        }
        else {
          this.toast.errorToastr(result['statusMsg'])
        }
      }))
    }




  }



  selectLeadType(dr_type) {
    let Index = this.networkType.findIndex(row => row.type == dr_type)
    if (Index != -1) {
      this.data.type_name = this.networkType[Index].module_name
      this.data.type = this.networkType[Index].type
    } else {
    }

  }

  add_to_list(fromdata){

    if (this.fromdata.contactType && this.fromdata.contactName && this.fromdata.contactMobile) {
      this.site_data.push({'contactType':this.fromdata.contactType,'contactName':this.fromdata.contactName,'contactMobile':this.fromdata.contactMobile })
      this.addTolistDisabled = false;
      this.fromdata.contactType='';
      this.fromdata.contactName='';
      this.fromdata.contactMobile='';
    }
     else {
      this.toast.errorToastr("Please Fill All The Above Required Fields...");
      this.fromdata.contactType='';
      this.fromdata.contactName='';
      this.fromdata.contactMobile='';
      this.addTolistDisabled = true;
      return;
    }
   

  }

  deleteSiteData(index) {
    console.log(index);
    console.log(this.site_data);
    this.site_data.splice(index, 1);
    
    
  }

  getStateList() {
    this.serve.post_rqst(0, "CustomerNetwork/getAllState").subscribe((response => {
      if (response['statusCode'] == 200) {

        this.states = response['all_state'];
      } else {
        this.toast.errorToastr(response['statusMsg']);
      }
    }));
  }

  //submit function
  submitDetail() {
    this.data.uid = this.userId;
    this.data.uname = this.userName;
    this.data.site_data=this.site_data
    this.data.status = this.status
    this.savingFlag = true;
    this.serve.post_rqst({ 'data': this.data }, "Enquiry/addSite").subscribe((result) => {
      if (result['statusCode'] == 200) {
console.log(result)
        this.toast.successToastr(result['statusMsg']);
        this.rout.navigate(['/site-list/']);
        setTimeout(() => {
          this.loader = false;
          this.savingFlag = false;
          this.router.navigate(['/site-list']);
        }, 700);
      }

      else {
        this.dialog.error(result['statusMsg']);
      }
    }, error => {
      this.loader = false;
      this.savingFlag = false;
    })
  }

  MobileNumber(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) { event.preventDefault(); }
  }



  getNetworkType() {
    this.serve.post_rqst('', "Enquiry/leadNetworkModule").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.networkType = result['modules'];
      }
      else {
        this.toast.errorToastr(result['statusMsg'])
      }
    }))
  }
  source_list: any = [];
  getsource_list() {
    this.serve.post_rqst('', "Enquiry/enquirySourceList").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.source_list = result['lead_source_list'];
      }
      else {
        this.toast.errorToastr(result['statusMsg'])
      }

    }))
  }
  getDistrict(val) {
    let st_name;
    if (val == 1) {
      st_name = this.data.state;
    }
    this.serve.post_rqst({ 'state_name': st_name }, "CustomerNetwork/getAllDistrict").subscribe((response => {
      if (response['statusCode'] == 200) {

        this.district_list = response['all_district'];
      } else {
        this.toast.errorToastr(response['statusMsg']);
      }
    }));
  }
  getArea(val) {
    let dist_name;
    if (val == 1) {
        dist_name = this.data.district;
    }
    let value = { "state": this.data.state, "district": dist_name }
    this.serve.post_rqst(value, "CustomerNetwork/getAreaData").subscribe((response => {
        if(response['statusCode'] == 200){
            this.city_area_list = response['area'];
        }else{
            this.toast.errorToastr(response['statusMsg']);
        }
        
    }));
}


  back(): void {
    this.location.back()
  }
}
